import React, { useState } from 'react';
import { FaAward } from 'react-icons/fa';
import portfolioData, { Certification } from '../data/portfolioData';
import CertificationModal from './CertificationModal';

const CertificationsSection: React.FC = () => {
  const [selectedCertification, setSelectedCertification] = useState<Certification | null>(null);

  return (
    <section id="certifications" className="section certifications">
      <div className="container">
        <h2 className="section__title">Certifications & Diplômes</h2>
        <p className="section__subtitle">
          Découvrez mes diplômes académiques et formations certifiantes. Cliquez sur une carte pour en savoir plus.
        </p>
        <div className="section__divider" />

        <div className="certifications__grid">
          {portfolioData.certifications.map((cert) => (
            <div
              key={cert.id}
              className="certifications__card"
              onClick={() => setSelectedCertification(cert)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  setSelectedCertification(cert);
                }
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="certifications__image-wrapper">
                <img src={cert.image} alt={cert.title} loading="lazy" />
                <div className="certifications__badge">
                  <FaAward size={14} />
                  <span>{cert.date}</span>
                </div>
              </div>
              <div className="certifications__body">
                <div className="certifications__issuer">{cert.issuer}</div>
                <h3 className="certifications__title">{cert.title}</h3>
                <p className="certifications__desc">{cert.summary}</p>
                <div className="certifications__footer">
                  <span className="btn btn--secondary btn--sm" style={{ width: '100%', justifyContent: 'center' }}>
                    Voir le détail & la certification
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedCertification && (
        <CertificationModal
          certification={selectedCertification}
          onClose={() => setSelectedCertification(null)}
        />
      )}
    </section>
  );
};

export default CertificationsSection;
